import './Support.scss';
import { Button } from '@scuf/common';
import { User } from 'oidc-client';
import { useSelector } from 'react-redux';
import { IOrganisationState } from '../../modules/commonUtils/Redux/Global/globalShared';
import { useFlags } from 'launchdarkly-react-client-sdk';

import CopyToClipboard from '../../components/CopyToClipboard/CopyToClipboard';
interface SupportProps {
  loggedInUser: User | null;
}
export default function Support({ loggedInUser }: SupportProps) {
  const { organisationList, gatewaySelectedOrganisation } = useSelector(
    (state: IOrganisationState) => state.globalShared
  );
  const featureFlags = useFlags();
  let selectedOrganisation: any;
  if (gatewaySelectedOrganisation) {
    selectedOrganisation = gatewaySelectedOrganisation.name;
  } else {
    const filteredOrganisationList = organisationList?.filter(item => {
      if (featureFlags['enableBacsFlowDistributor'])
        return item.orgType === 'Contractor' || item.zuoraAccountNo !== null;
      else
        return item.zuoraAccountNo !== null && item.orgType !== 'Distributor';
    });
    if (filteredOrganisationList?.length > 0 && !gatewaySelectedOrganisation) {
      filteredOrganisationList.sort((a, b) => a.name.localeCompare(b.name));
      selectedOrganisation = filteredOrganisationList[0].name;
    }
  }
  const environmentVariables = (window as any).ENV;
  const email =
    environmentVariables.SUPPORT_EMAIL ||
    'connectedBuildingSupport@honeywell.com';
  const emailHandler = () => {
    let subject: string = '';
    if (selectedOrganisation)
      subject = `${loggedInUser?.profile.name} from ${selectedOrganisation} need help !`;
    else subject = `${loggedInUser?.profile.name} need help !`;
    const mailToLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
    window.location.href = mailToLink;
  };
  return (
    <div className="h-support-page">
      <h2>Help & Support</h2>
      <p>
        Need help or have a question? Feel free to reach out to us - we’re here
        to support you every step of the way!
      </p>
      <Button
        className="h-support-btn"
        onClick={() => emailHandler()}
        type="primary"
        content="Contact Support team"
      />
      <div className="support-mail-container">
        <p>
          or reach us at <span className="support-email">{email}</span>
        </p>
        <div className="copy-button">
          <CopyToClipboard text={email} />
        </div>
      </div>
    </div>
  );
}
